angular.module('gym.components').directive('displayDataType', function() {
  return {
    restrict: 'E',
    template: require('templates/components/shared/display_data_type.html.slim'),
    scope: {
      value: '=',
      type: '=',
      units: '='
    },
    controller: ["$rootScope", "$scope", "$filter", function($rootScope, $scope, $filter) {
      $scope.parseDate = function(value) {
        var date;
        if (value) {
          date = new Date(value);
          if (isNaN(date.valueOf())) {
            return value;
          }
          return moment(value).format('MMM D, YYYY');
        }
      };
      $scope.parseDatetime = function(value) {
        var date;
        if (value) {
          date = new Date(value);
          if (isNaN(date.valueOf())) {
            return value;
          }
          return moment(date).format('lll');
        }
      };
      $scope.parseCurrency = function(value) {
        var symbol;
        symbol = $rootScope.gym.currency_symbol;
        if (value) {
          return $filter('currency')(value, symbol);
        }
      };
      $scope.isZero = function(value) {
        return value === 0 || value === '0';
      };
      $scope.parseNumber = function(value) {
        return $filter('number')(value);
      };
      return $scope.parseBoolean = function(value) {
        switch (value) {
          case 't':
            return 'Yes';
          case 'f':
            return 'No';
          default:
            return value;
        }
      };
    }]
  };
});
